module.exports = __webpack_public_path__ + "media/honey-icons/icon-hive-white-4958f694.svg";